import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Button  } from 'antd';
import './Commission.css';
import * as actions from '../../store/actions';
import { connect } from 'react-redux';
import { messages } from './Translate';
import { getImage } from '../../utils/common';
import  CommissionTable  from './CommissionTable';

class Commission extends Component {
    constructor(props) {
        super(props);
        this.state = { earningmodel: 'LM' }
    }

    changeEarningModel = (model) => {
        this.setState({ earningmodel: model })
    }

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div className='commission-div'>
                <Row type="flex">
                    <Col xs={24} xl={24} className="commission commission-flex-content">
                        <div className="commission commission-title">
                            {formatMessage(messages.Commission_Title_LM)}
                        </div>
                        <div className="commission commission-desc">
                            {formatMessage(messages.Commission_Desc_LM).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}
                        </div>
                    </Col>
                    <Col xs={24} className='commission commission-flex-content commission-tab'>
                        <Button type="primary" className= {this.state.earningmodel === 'LM' ? "commission-top-button" : "commission-top-button-inactive"}
                            onClick={() => this.changeEarningModel('LM')}
                        >
                            {formatMessage(messages.Commission_Top_Btn_LM)}
                        </Button>
                        <Button type="primary" className={this.state.earningmodel === 'CM' ? "commission-top-button" : "commission-top-button-inactive"}
                            onClick={() => this.changeEarningModel('CM')}
                        >
                            {formatMessage(messages.Commission_Top_Btn_CM)}
                        </Button>
                    </Col>
                    {this.state.earningmodel === "LM" ?
                        <Col offset={this.props.mobile ? 1 : 2} xs={20} xl={20} className='commission commission-flex-content'>
                            <CommissionTable />
                        </Col> :
                        <Col offset={this.props.mobile ? 1 : 2} sm={20} xs={20} xl={20} className='commission-flex-content CM-img-container'>
                            {this.props.mobile ? 
                            <div>
                                <Col sm={24} xs={24}>
                                    <br></br>
                                    <br></br>
                                    <div className="commission-desc-CM">
                                        {formatMessage(messages.Commission_Desc_CM).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}
                                    </div>
                                    <div className="commission-img-CM">
                                        <img alt="CM Model" src={getImage("homepage/Sec-5_2677_CM.png")} />
                                    </div>
                                </Col>
                            </div>
                            :
                            <div>
                                <Col xs={30} xl={30}>
                                    <br></br>
                                    <br></br>
                                    <div className="commission-desc-CM">
                                        {formatMessage(messages.Commission_Desc_CM).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}
                                    </div>
                                    <div className="commission-img-CM">
                                        <img alt="CM Model" src={getImage("homepage/Sec-5_2677_CM.png")} />
                                    </div>
                                </Col>
                            </div>
                            }
                            
                        </Col>}
                        <Col offset={2} xs={20} xl={20} className="commission-bottom-button commission-flex-content">
                            <Button type="primary"
                                onClick={() => this.props.openPopUp(this.state.earningmodel + "CommissionPopUp")}
                            >
                                {formatMessage(messages.Commission_Button_KnowMore)}
                            </Button>
                        </Col>
                </Row>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        openPopUp: (type, param) => dispatch(actions.openPopUp(type, param))
    };
}

const mapStateToProps = state => {
    return {
      mobile: state.responsiveui.mobile
    };
  };

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Commission));